import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import BurguerButton from './BurguerButton.jsx'

function Navbar() {

  const [clicked, setClicked] = useState(false)
  const handleClick = () => {
    if (window.innerWidth <= 768) {
    setClicked(!clicked);
  }
};

useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setClicked(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <NavContainer>
        <h2>Ariadna | <span>EventMakeUpp</span></h2>
        <div className={`links ${clicked ? 'active' : ''}`}>
          <a onClick={handleClick} href="#">Inicio</a>
          <a onClick={handleClick} href="#makeup">MakeUp</a>
          <a onClick={handleClick} href="#galeria">Galeria</a>
          <a onClick={handleClick} href="#SobreAriadna">Sobre Ariadna</a>
          <a onClick={handleClick} href="#contactos">Contactos</a>
        </div>
        <div className='redes'>
        <a href='https://www.instagram.com/ariadna.eventmakeupp/'><i className="bi bi-instagram"></i></a> 
        <a href="https://wa.link/qv79u1"><i className="bi bi-whatsapp"></i></a>
        </div>
        <div className='burguer'>
          <BurguerButton clicked={clicked} handleClick={handleClick} />
        </div>
        <BgDiv className={`initial ${clicked ? ' active' : ''}`}></BgDiv>
      </NavContainer>
    </>
  )
}

export default Navbar

const NavContainer = styled.nav`
  h2{
    margin-left: 2rem;
    color:   #999b84;
    font-weight: 400px;
    box-shadow: 1px 1px 2px   #999b84;
    span{
      font-weight: bold;
    }

}
  padding: .4rem;
  background-color: #f4eeed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  a{
    color: black;
    text-decoration: none;
    margin-right: 3rem;
  }

  .links{
    position: absolute;
    top: -700px;
    left: -2000px;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    transition: all .5s ease;
    a{
      color: black;
      font-size: 2rem;
      display: block;
    }

    @media(min-width: 768px){
        position: initial;
        margin: 0;
        a{
          font-size: 1rem;
          color:  #999b84;
          display: inline;
        }
        display: block;
      }
    }
    .links.active{
      width: 100%;
      display: block;
      position: absolute;
      margin-left: auto;
      margin-right: auto;
      top: 30%;
      left: 0;
      right: 0;
      text-align: center;
      a{
        font-size: 2rem;
        margin-top: 1rem;
        color: black;
      }
    }
    .burguer{
      @media(min-width: 768px){
        display: none;
      }
    }
  
    i {
      font-size: 20px;
      margin: 10px;
    }
  }
  
  @media (max-width: 578px){
    .redes i{
      margin: 0;
    }
  }

  `
  
  const BgDiv = styled.div`
    background-color: #f4eeed;
    position: absolute;
    top: -1000px;
    left: -1000px;
    width: 100%;
    height: 100%;
    z-index: -1;
    transition: all .6s ease ;
    
    &.active{
      border-radius: 0 0 80% 0;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  
  
  `